<template>
  <div class="page-title" :class="{'-border' : !menu}">
    <div class="page-title__title">{{title}}</div>
    <div v-if="menu" class="page-title__menu">
      <router-link
        v-for="(tab,index) in tabs"
        :key="index"
        :to="{name: tab.name}"
        v-slot="{ href, route, navigate, isActive }"
      >
        <a
          :href="href"
          class="page-title__menu__item"
          :class="{'-active': isActive}"
          @click="navigate"
        >{{tab.meta.title}}</a>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    menuby: {
      type: String,
      default: null
    },
    menu: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tabs() {
      let _tabs = this.$router.options.routes.filter(
        item => item.name == this.menuby
      )[0].children;

      return _tabs;
    }
  }
};
</script>